/*
 * Blendet den Hinweisbaustein der App "EU Widerruf Button" unter dem Formular aus.
 * Mit dem Anbieter abgestimmt und freigegeben (Stand 24.09.2026).
 *
 * Reines CSS reicht nicht mehr: Die App setzt seit einem Update inline
 * "display:flex !important; visibility:visible !important; opacity:1 !important"
 * auf das Element, und Inline-!important schlaegt jede Stylesheet-Regel.
 * Deshalb wird das Attribut hier entfernt - die Regel in custom.css greift dann.
 */
(function () {
  'use strict';

  var SELEKTOR = 'div[id$="__eu_widerruf_button_form_inline_7MzyhR"] > div:nth-child(2)';

  function ausblenden() {
    var treffer = document.querySelectorAll(SELEKTOR);
    for (var i = 0; i < treffer.length; i++) {
      var el = treffer[i];
      if (el.dataset.wfBrandingEntfernt === '1') { continue; }
      if (el.querySelector('a[href*="euwiderrufsbutton.de"]') === null) { continue; }
      el.removeAttribute('style');
      el.dataset.wfBrandingEntfernt = '1';
    }
  }

  function start() {
    ausblenden();
    if (!document.querySelector('div[id$="__eu_widerruf_button_form_inline_7MzyhR"]')) { return; }
    new MutationObserver(ausblenden).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*
 * Cookie-Einstellungen und Haendlerkarte (Stand 19.10.2026).
 *
 * 1. Der Menuepunkt "Cookie-Einstellungen" im Footer zeigt noch auf
 *    "/?id=GDPR_...", ein Ueberbleibsel einer frueheren Consent-App. Der Klick
 *    oeffnet stattdessen den Einstellungsdialog von iubenda (App "Complianz").
 *    Frueher stand das als Inline-Skript in theme.liquid und ist beim
 *    Theme-Update auf Impact 7.2.0 verloren gegangen - deshalb jetzt hier.
 *
 * 2. Die Stockist-Karte auf /pages/kontakt laedt Google Maps. iubenda blockt
 *    Google Maps (Anbieter 178) bis zur Einwilligung in Zweck 3
 *    ("Nutzererfahrung"). Ohne Einwilligung bleibt die Karte grau - dann
 *    erscheint darauf ein Hinweis mit Link zu den Einstellungen. Stockist
 *    baut die Karte nach einer spaeteren Einwilligung nicht selbst auf,
 *    daher wird die Seite in diesem Fall einmal neu geladen.
 */
(function () {
  'use strict';

  var ZWECK_KARTE = '3';

  var TEXTE = {
    de: {
      text: 'Die Karte wird über Google Maps geladen und erscheint erst, wenn Sie in den Cookie-Einstellungen der Kategorie „Nutzererfahrung“ zustimmen. Die Händlerliste funktioniert auch ohne Karte.',
      button: 'Cookie-Einstellungen öffnen'
    },
    en: {
      text: 'The map is provided by Google Maps and is only shown once you allow the “Experience” category in the cookie settings. The list of retailers works without the map.',
      button: 'Open cookie settings'
    }
  };

  function iubendaBereit() {
    return !!(window._iub && _iub.cs && _iub.cs.api && typeof _iub.cs.on === 'function');
  }

  function wennIubendaBereit(fn) {
    if (iubendaBereit()) { fn(); return; }
    var versuche = 0;
    var timer = setInterval(function () {
      if (iubendaBereit()) { clearInterval(timer); fn(); }
      else if (++versuche > 150) { clearInterval(timer); }
    }, 100);
  }

  function einstellungenOeffnen() {
    wennIubendaBereit(function () { _iub.cs.api.openPreferences(); });
  }

  // 1. Footer-Link
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="id=GDPR_"], [data-cookie-einstellungen]');
    if (!link) { return; }
    e.preventDefault();
    einstellungenOeffnen();
  });

  if (/[?&]id=GDPR_/.test(window.location.search)) { einstellungenOeffnen(); }

  // 2. Hinweis auf der Stockist-Karte
  function karteErlaubt() {
    var prefs = _iub.cs.api.getPreferences();
    return !!(prefs && prefs.purposes && prefs.purposes[ZWECK_KARTE] === true);
  }

  function hinweisBauen() {
    var sprache = (document.documentElement.lang || 'de').slice(0, 2) === 'de' ? 'de' : 'en';
    var hinweis = document.createElement('div');
    hinweis.className = 'karte-consent-hinweis';
    var text = document.createElement('p');
    text.textContent = TEXTE[sprache].text;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button';
    button.setAttribute('data-cookie-einstellungen', '');
    button.textContent = TEXTE[sprache].button;
    hinweis.appendChild(text);
    hinweis.appendChild(button);
    return hinweis;
  }

  function startKarte() {
    if (!document.querySelector('[data-stockist-widget-tag], #stockist-widget')) { return; }

    var hinweis = null;
    var karteWarGesperrt = false;
    var beobachter = null;

    function einsetzen() {
      if (hinweis && hinweis.isConnected) { return true; }
      var ziel = document.querySelector('#stockist-widget .stockist-map-inner');
      if (!ziel) { return false; }
      hinweis = hinweis || hinweisBauen();
      ziel.appendChild(hinweis);
      return true;
    }

    // Stockist rendert die Karte nach dem ersten Aufbau teils neu und wirft
    // den Hinweis dabei raus - der Beobachter setzt ihn dann wieder ein.
    function zeigen() {
      karteWarGesperrt = true;
      einsetzen();
      if (beobachter) { return; }
      beobachter = new MutationObserver(einsetzen);
      beobachter.observe(document.body, { childList: true, subtree: true });
    }

    function pruefen() {
      if (!karteErlaubt()) { zeigen(); return; }
      if (karteWarGesperrt) { window.location.reload(); }
    }

    wennIubendaBereit(function () {
      pruefen();
      _iub.cs.on('preferenceExpressedOrNotNeeded', pruefen);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startKarte);
  } else {
    startKarte();
  }
})();

/*
 * Deutsche Texte auf den /en/-Seiten uebersetzen (Stand 29.10.2026).
 *
 * 1. Die App "O:Request a Quote" (Quote Snap, Omega) kennt nur einen Satz
 *    Texte fuer alle Sprachen. Auf den /en/-Seiten stand deshalb "Anfragen"
 *    und das Anfrage-Fenster war deutsch.
 * 2. Das Akkordeon "Technische Informationen & Sicherheit" auf den
 *    Produktseiten kommt aus der alten PHP-App (cukero.han-solo.net/en.php),
 *    die Ueberschrift und "Seiten" sind dort auch auf Englisch deutsch.
 *
 * Beide werden nachtraeglich eingefuegt bzw. neu gerendert, daher der
 * MutationObserver. Die deutschen Texte in der App bleiben massgeblich;
 * aendert jemand dort eine Beschriftung, muss sie hier mitgepflegt werden.
 */
(function () {
  'use strict';

  if ((document.documentElement.lang || 'de').slice(0, 2) === 'de') { return; }

  var TEXTE = {
    'Anfragen': 'Request a quote',
    'Produktanfrage': 'Product inquiry',
    'Weiter einkaufen': 'Continue shopping',
    'Produkt': 'Product',
    'Menge': 'Quantity',
    'Name eingeben': 'Enter your name',
    'E-Mail-Adresse': 'Email address',
    'E-Mail-Adresse eingeben': 'Enter your email address',
    'Firma': 'Company',
    'Firmenname eingeben': 'Enter your company name',
    'Nachricht': 'Message',
    'Nachricht eingeben': 'Enter your message',
    'Telefon': 'Phone',
    'Telefonnummer eingeben': 'Enter your phone number',
    'Produktanfrage absenden': 'Send inquiry',
    'Produktanfrage übermittelt': 'Inquiry sent',
    'Vielen Dank für Ihre Produktanfrage.': 'Thank you for your inquiry.',
    'Keine Produktanfragen': 'No product inquiries',
    'Ihre Produktanfrage enthält keine Produkte': 'Your inquiry does not contain any products',
    'Technische Informationen & Sicherheit': 'Technical information & safety'
  };

  // "(14 Seiten, 4.1 MB)" im Akkordeon der PHP-App
  var SEITEN = /(\d+) Seiten?\b/g;

  var BEREICH = '[class*="omgrfq"], [id*="omgrfq"], #dynamic-content';

  function uebersetzen() {
    var bereiche = document.querySelectorAll(BEREICH);
    for (var i = 0; i < bereiche.length; i++) {
      var walker = document.createTreeWalker(bereiche[i], NodeFilter.SHOW_TEXT, null);
      var knoten;
      while ((knoten = walker.nextNode())) {
        var text = knoten.nodeValue.trim();
        if (text && TEXTE.hasOwnProperty(text)) {
          knoten.nodeValue = knoten.nodeValue.replace(text, TEXTE[text]);
        } else if (SEITEN.test(knoten.nodeValue)) {
          knoten.nodeValue = knoten.nodeValue.replace(SEITEN, function (m, n) { return n + (n === '1' ? ' page' : ' pages'); });
        }
        SEITEN.lastIndex = 0;
      }
      var felder = bereiche[i].querySelectorAll('[placeholder]');
      for (var j = 0; j < felder.length; j++) {
        var ph = felder[j].getAttribute('placeholder').trim();
        if (TEXTE.hasOwnProperty(ph)) { felder[j].setAttribute('placeholder', TEXTE[ph]); }
      }
    }
  }

  var geplant = false;
  function planen() {
    if (geplant) { return; }
    geplant = true;
    requestAnimationFrame(function () { geplant = false; uebersetzen(); });
  }

  function start() {
    uebersetzen();
    new MutationObserver(planen).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
